import Button from '@/components/Button/Button';
import { styled } from '@mui/material/styles';
import CancelIcon from '@/assets/cancel2.svg?react';
import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';

export type TabName =
  | 'gameDetails'
  | 'complianceDocuments'
  | 'marketingAssets';

const GameTabs = ({
  open,
  onOpen,
}: {
  open: TabName;
  onOpen: (v: TabName) => void;
}) => {
  const navigate = useNavigate();
  const handleCancelClick = () => {
    navigate('/games');
  };

  return (
    <Root>
      <Header>
        <TabButtons>
          <TabButton
            selected={open === 'gameDetails'}
            onClick={() => onOpen('gameDetails')}
          >
            <FormattedMessage
              id="gameDetails"
              defaultMessage="Game Details"
            />
          </TabButton>
          <TabButton
            selected={open === 'complianceDocuments'}
            onClick={() => onOpen('complianceDocuments')}
          >
            <FormattedMessage
              id="complianceDocuments"
              defaultMessage="Compliance Documents"
            />
          </TabButton>
          <TabButton
            selected={open === 'marketingAssets'}
            onClick={() => onOpen('marketingAssets')}
          >
            <FormattedMessage
              id="marketingAssets"
              defaultMessage="Marketing Assets"
            />
          </TabButton>
        </TabButtons>
        <StyledButton
          onClick={handleCancelClick}
          aria-label="Cancel Button"
        >
          <CancelIcon />
        </StyledButton>
      </Header>
    </Root>
  );
};

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  borderBottom: `1px solid ${theme.palette.grey200}`,
}));

const TabButtons = styled('div')({
  marginTop: 20,
  display: 'flex',
  flexGrow: 1,
  gap: 10,
  height: 43,
});

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0.5),
  padding: theme.spacing(1),
  path: {
    stroke: theme.palette.iconBlack,
  },
}));

const TabButton = styled('div')<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    flexGrow: 1,
    maxWidth: 180,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    borderBottom: `3px solid ${
      selected ? theme.palette.primary.main : 'transparent'
    }`,
    transition: '0.3s all ease-in-out',
    cursor: 'pointer',
    textAlign: 'center',
    height: 44,
    padding: '12px',
    color: selected
      ? theme.palette.primary.main
      : theme.palette.textPrimaryBlack,
  }),
);

export default GameTabs;
